export default {"src":"/kaimono/_next/static/media/cn_wamazing_transport_h.503732fc.svg","height":116,"width":331};